export function ggetPosition(element) {
  if (!element) element = window.event;
  var elem = element, tagname = '', x = 0, y = 0;
  while ((typeof (elem) == 'object') && (typeof (elem.tagName) != 'undefined')) {
    y += elem.offsetTop;
    x += elem.offsetLeft;
    tagname = elem.tagName.toUpperCase();
    if (tagname == 'BODY') elem = 0;
    if (tagname == 'HTML') elem = 0;
    if (typeof (elem) == 'object')
      if (typeof (elem.offsetParent) == 'object')
        elem = elem.offsetParent;
  }
  return { x: x, y: y };
}

export function openWin(was, w, h) {
  var neues = window.open(was, 'Nummer', 'location=no,menubar=no,personalbar=no,statusbar=no,toolbar=no,width=' + w + ', height=' + h);
  neues.focus();
}
export function closeWin() { window.close('Nummer'); }
export function m_over(wat, pix) { wat.style.backgroundPosition = '0px -' + pix + 'px'; wat.style.color = '#ff0000'; }
export function m_down(wat, pix) { wat.style.backgroundPosition = ' 0px -' + (3 * pix) + 'px'; }
export function m_out(wat, pix) { wat.style.backgroundPosition = ' 0px -' + (2 * pix) + 'px'; wat.style.color = '#aaaaaa'; }
